export const GetObjectKey = (value,object) => {
    for (const key in object) {
      if (object[key] === value) {
        return key;
      }
    }
    return null; // Return null if the value is not found
  };